import type { AdminOverviewDto } from "@shelflist/shared";
import { queryOptions } from "@tanstack/react-query";
import { api, call } from "./api";

export const adminKeys = {
  overview: ["admin", "overview"] as const,
};

/** Refresh interval of the overview while a job is queued or running. */
export const OVERVIEW_POLL_MS = 5000;

/** Polling rule: every 5 s while a job is queued or running, otherwise off. */
export function overviewRefetchInterval(data: AdminOverviewDto | undefined): number | false {
  return data && data.jobs.queued + data.jobs.running > 0 ? OVERVIEW_POLL_MS : false;
}

export const adminOverviewQuery = queryOptions({
  queryKey: adminKeys.overview,
  queryFn: (): Promise<AdminOverviewDto> => call(api.admin.overview.$get()),
  refetchInterval: (query) => overviewRefetchInterval(query.state.data),
});
